import Swiper, { Navigation, Pagination } from 'swiper';

if (document.querySelector('.history-slider')) {
    const swiper = new Swiper('.history-slider .swiper', {
        modules: [Navigation, Pagination],
        loop: true,
        speed: 700,
        spaceBetween: 32,
        slidesPerView: 1,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
        },
        navigation: {
            nextEl: '.swiper-next-btn',
            prevEl: '.swiper-prev-btn',
        },
    });
}
